var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s-date-range-picker"},[_vm._v(" date range picker ")])}
var staticRenderFns = []

export { render, staticRenderFns }